import { render } from "./PopModelDiy.vue?vue&type=template&id=c25c4e7c&scoped=true"
import script from "./PopModelDiy.vue?vue&type=script&lang=js"
export * from "./PopModelDiy.vue?vue&type=script&lang=js"

import "./PopModelDiy.vue?vue&type=style&index=0&id=c25c4e7c&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25c4e7c"]])

export default __exports__